import type { LegalPack } from './types'

export const privacyPolicy: LegalPack = {
  ru: {
    title: 'Политика конфиденциальности',
    meta: ['Версия: 1.0', 'Дата: 25.06.2025', 'Статус: Действует'],
    effective: '25.06.2025',
    version: '1.0',
    sections: [
      {
        title: '1. Общие положения',
        blocks: [
          { p: '1.1. Настоящая Политика конфиденциальности и обработки персональных данных ОсОО «АльфаБит Пэймэнтс» (далее – Политика) определяет порядок сбора, обработки, использования, хранения, передачи, защиты и уничтожения персональных данных пользователей платежной системы AlfaBitPay (далее - Пользователи) ОсОО «АльфаБит Пэймэнтс» (далее – Общество).' },
          { p: 'Общество обязуется защищать конфиденциальность и обеспечивать безопасность персональных данных в соответствии с законодательством Кыргызской Республики.' },
        ],
      },
      {
        title: '2. Какие данные мы собираем',
        blocks: [{
          cards: [
            { title: 'Персональные данные', items: ['Фамилия, имя, отчество', 'Дата и место рождения', 'Паспортные данные', 'Адрес регистрации и проживания', 'Номер телефона', 'Адрес электронной почты'] },
            { title: 'Финансовые данные', items: ['Информация о банковских счетах', 'История транзакций', 'Данные о платежах', 'Информация о лимитах и тарифах'] },
            { title: 'Технические данные', items: ['IP-адрес', 'Информация об устройстве', 'Данные о браузере', 'Логи доступа к системе'] },
          ],
        }],
      },
      {
        title: '3. Цели обработки данных',
        blocks: [
          { p: 'Мы обрабатываем ваши персональные данные для следующих целей:' },
          { ul: ['Предоставление услуг платежной системы', 'Идентификация и аутентификация пользователей', 'Выполнение требований законодательства', 'Предотвращение мошенничества и отмывания денег', 'Улучшение качества услуг', 'Обеспечение безопасности системы'] },
        ],
      },
      {
        title: '4. Правовые основания обработки',
        blocks: [
          { p: 'Обработка персональных данных осуществляется на следующих основаниях:' },
          { pairs: [
            { title: 'Согласие субъекта данных', text: 'Обработка данных с вашего явного согласия' },
            { title: 'Исполнение договора', text: 'Обработка, необходимая для предоставления услуг' },
            { title: 'Выполнение обязательств', text: 'Обработка, требуемая законодательством' },
            { title: 'Законные интересы', text: 'Обработка для обеспечения безопасности и качества услуг' },
          ] },
        ],
      },
      {
        title: '5. Меры защиты данных',
        blocks: [
          { p: 'Мы принимаем следующие меры для защиты ваших данных:' },
          { pairs: [
            { title: 'Шифрование данных', text: 'Все данные шифруются при передаче и хранении' },
            { title: 'Контроль доступа', text: 'Строгий контроль доступа к персональным данным' },
            { title: 'Мониторинг', text: 'Постоянный мониторинг системы безопасности' },
            { title: 'Резервное копирование', text: 'Регулярное резервное копирование данных' },
          ] },
        ],
      },
      {
        title: '6. Передача данных третьим лицам',
        blocks: [{ p: 'Передача персональных данных третьим лицам осуществляется при условии соблюдения требований законодательства Кыргызской Республики о персональных данных и только в объеме, необходимом для достижения целей обработки.' }],
      },
      {
        title: '7. Ваши права',
        blocks: [
          { p: 'Пользователь вправе:' },
          { ul: ['получать информацию об обработке своих персональных данных;', 'запрашивать уточнения, обновления и исправления персональных данных;', 'по заявлению блокировать доступ к ЭК и личному кабинету на сайте Общества;', 'обращаться в Общество по вопросам обработки персональных данных;', 'защищать свои права в порядке, установленном законодательством Кыргызской Республики.'] },
        ],
      },
      {
        title: '8. Сроки хранения данных',
        blocks: [{ p: 'Срок хранения персональных данных определяется законодательством Кыргызской Республики, нормативными актами Национального банка Кыргызской Республики и внутренними документами Общества.' }],
      },
      {
        title: '9. Cookies и аналогичные технологии',
        blocks: [
          { p: 'Мы используем cookies и аналогичные технологии для улучшения работы системы и обеспечения безопасности:' },
          { pairs: [
            { title: 'Необходимые cookies', text: 'Для работы системы и безопасности' },
            { title: 'Аналитические cookies', text: 'Для анализа использования системы' },
            { title: 'Функциональные cookies', text: 'Для запоминания ваших предпочтений' },
          ] },
        ],
      },
      {
        title: '10. Изменения в политике',
        blocks: [
          { p: 'Мы можем изменять настоящую Политику. Об изменениях вы будете уведомлены через личный кабинет или по электронной почте.' },
          { p: 'Продолжение использования услуг после изменения Политики означает согласие с новыми условиями.' },
        ],
      },
      {
        title: '11. Контактная информация',
        blocks: [{ p: 'По вопросам обработки персональных данных обращайтесь через контакты, указанные внизу страницы правовой информации.' }],
      },
    ],
  },
  en: {
    title: 'Privacy Policy',
    meta: ['Version: 1.0', 'Date: 25.06.2025', 'Status: Active'],
    effective: '25.06.2025',
    version: '1.0',
    sections: [
      {
        title: '1. General provisions',
        blocks: [
          { p: '1.1. This Privacy and Personal Data Processing Policy of AlfaBit Payments LLC (the Policy) sets out how personal data of users of the AlfaBitPay payment system (Users) is collected, processed, used, stored, transferred, protected and destroyed by AlfaBit Payments LLC (the Company).' },
          { p: 'The Company protects the confidentiality and security of personal data in accordance with the laws of the Kyrgyz Republic.' },
        ],
      },
      {
        title: '2. Data we collect',
        blocks: [{
          cards: [
            { title: 'Personal data', items: ['Last name, first name, middle name', 'Date and place of birth', 'Passport details', 'Registered and residential address', 'Phone number', 'Email address'] },
            { title: 'Financial data', items: ['Bank account information', 'Transaction history', 'Payment details', 'Limits and tariff information'] },
            { title: 'Technical data', items: ['IP address', 'Device information', 'Browser data', 'System access logs'] },
          ],
        }],
      },
      {
        title: '3. Purposes of processing',
        blocks: [
          { p: 'We process your personal data for the following purposes:' },
          { ul: ['Providing payment system services', 'Identifying and authenticating users', 'Complying with legal requirements', 'Preventing fraud and money laundering', 'Improving service quality', 'Keeping the system secure'] },
        ],
      },
      {
        title: '4. Legal grounds',
        blocks: [
          { p: 'Personal data is processed on the following grounds:' },
          { pairs: [
            { title: 'Consent of the data subject', text: 'Processing based on your explicit consent' },
            { title: 'Performance of a contract', text: 'Processing required to provide the services' },
            { title: 'Legal obligations', text: 'Processing required by law' },
            { title: 'Legitimate interests', text: 'Processing to keep the service secure and of good quality' },
          ] },
        ],
      },
      {
        title: '5. Protection measures',
        blocks: [
          { p: 'We take the following measures to protect your data:' },
          { pairs: [
            { title: 'Encryption', text: 'Data is encrypted in transit and at rest' },
            { title: 'Access control', text: 'Strict control over access to personal data' },
            { title: 'Monitoring', text: 'Continuous monitoring of the security system' },
            { title: 'Backups', text: 'Regular backups of data' },
          ] },
        ],
      },
      {
        title: '6. Sharing with third parties',
        blocks: [{ p: 'Personal data is shared with third parties only when the personal data laws of the Kyrgyz Republic are observed, and only to the extent needed for the purposes of processing.' }],
      },
      {
        title: '7. Your rights',
        blocks: [
          { p: 'You have the right to:' },
          { ul: ['receive information about how your personal data is processed;', 'ask for your personal data to be clarified, updated or corrected;', 'request that access to your e-wallet and personal account on the Company’s website be blocked;', 'contact the Company about personal data processing;', 'protect your rights as provided by the laws of the Kyrgyz Republic.'] },
        ],
      },
      {
        title: '8. Retention',
        blocks: [{ p: 'Personal data is kept for the period set by the laws of the Kyrgyz Republic, the regulations of the National Bank of the Kyrgyz Republic and the Company’s internal documents.' }],
      },
      {
        title: '9. Cookies and similar technologies',
        blocks: [
          { p: 'We use cookies and similar technologies to run the system and keep it secure:' },
          { pairs: [
            { title: 'Necessary cookies', text: 'Required for the system to work and stay secure' },
            { title: 'Analytics cookies', text: 'Used to understand how the system is used' },
            { title: 'Functional cookies', text: 'Used to remember your preferences' },
          ] },
        ],
      },
      {
        title: '10. Changes to this policy',
        blocks: [
          { p: 'We may change this Policy. You will be notified through your personal account or by email.' },
          { p: 'Continuing to use the services after the Policy changes means you accept the new terms.' },
        ],
      },
      {
        title: '11. Contact information',
        blocks: [{ p: 'For questions about personal data processing, use the contacts listed at the bottom of the legal information page.' }],
      },
    ],
  },
  ky: {
    title: 'Купуялуулук саясаты',
    meta: ['Версия: 1.0', 'Күнү: 25.06.2025', 'Статус: Күчүндө'],
    effective: '25.06.2025',
    version: '1.0',
    sections: [
      {
        title: '1. Жалпы жоболор',
        blocks: [
          { p: '1.1. «АльфаБит Пэймэнтс» ЖЧКсынын ушул Купуялуулук жана жеке маалыматтарды иштетүү саясаты (мындан ары — Саясат) AlfaBitPay төлөм системасынын колдонуучуларынын (мындан ары — Колдонуучулар) жеке маалыматтарын «АльфаБит Пэймэнтс» ЖЧКсы (мындан ары — Коом) кантип чогултарын, иштетерин, колдонорун, сактарын, берерин, коргой турганын жана жок кыларын аныктайт.' },
          { p: 'Коом жеке маалыматтардын купуялуулугун жана коопсуздугун Кыргыз Республикасынын мыйзамдарына ылайык коргоого милдеттенет.' },
        ],
      },
      {
        title: '2. Кайсы маалыматтарды чогултабыз',
        blocks: [{
          cards: [
            { title: 'Жеке маалыматтар', items: ['Фамилия, аты, атасынын аты', 'Туулган күнү жана жери', 'Паспорттук маалыматтар', 'Каттоо жана жашаган дареги', 'Телефон номери', 'Электрондук почта'] },
            { title: 'Каржылык маалыматтар', items: ['Банк эсептери жөнүндө маалымат', 'Транзакциялардын тарыхы', 'Төлөмдөр жөнүндө маалымат', 'Лимиттер жана тарифтер жөнүндө маалымат'] },
            { title: 'Техникалык маалыматтар', items: ['IP-дарек', 'Түзмөк жөнүндө маалымат', 'Браузердин маалыматы', 'Системага кирүү логдору'] },
          ],
        }],
      },
      {
        title: '3. Иштетүүнүн максаттары',
        blocks: [
          { p: 'Жеке маалыматтарыңызды төмөнкү максаттарда иштетебиз:' },
          { ul: ['Төлөм системасынын кызматтарын көрсөтүү', 'Колдонуучуларды идентификациялоо жана аутентификациялоо', 'Мыйзамдын талаптарын аткаруу', 'Алдамчылыктын жана кылмыштуу кирешени легалдаштыруунун алдын алуу', 'Кызматтын сапатын жакшыртуу', 'Системанын коопсуздугун камсыз кылуу'] },
        ],
      },
      {
        title: '4. Иштетүүнүн укуктук негиздери',
        blocks: [
          { p: 'Жеке маалыматтар төмөнкү негиздерде иштетилет:' },
          { pairs: [
            { title: 'Маалымат субъектинин макулдугу', text: 'Сиздин ачык макулдугуңуз менен иштетүү' },
            { title: 'Келишимди аткаруу', text: 'Кызмат көрсөтүү үчүн зарыл иштетүү' },
            { title: 'Милдеттенмелерди аткаруу', text: 'Мыйзам талап кылган иштетүү' },
            { title: 'Мыйзамдуу кызыкчылыктар', text: 'Коопсуздук жана кызматтын сапаты үчүн иштетүү' },
          ] },
        ],
      },
      {
        title: '5. Коргоо чаралары',
        blocks: [
          { p: 'Маалыматыңызды коргоо үчүн төмөнкү чараларды көрөбүз:' },
          { pairs: [
            { title: 'Маалыматты шифрлөө', text: 'Бардык маалымат берүүдө жана сактоодо шифрленет' },
            { title: 'Кирүүнү көзөмөлдөө', text: 'Жеке маалыматка кирүү катуу көзөмөлдөнөт' },
            { title: 'Мониторинг', text: 'Коопсуздук системасы тынымсыз көзөмөлдөнөт' },
            { title: 'Камдык көчүрмө', text: 'Маалыматтын үзгүлтүксүз камдык көчүрмөсү' },
          ] },
        ],
      },
      {
        title: '6. Үчүнчү жактарга берүү',
        blocks: [{ p: 'Жеке маалымат үчүнчү жактарга Кыргыз Республикасынын жеке маалыматтар жөнүндө мыйзамы сакталганда жана иштетүү максаттары үчүн зарыл көлөмдө гана берилет.' }],
      },
      {
        title: '7. Сиздин укуктарыңыз',
        blocks: [
          { p: 'Колдонуучу төмөнкүлөргө укуктуу:' },
          { ul: ['жеке маалыматтарын иштетүү жөнүндө маалымат алууга;', 'жеке маалыматтарын тактоону, жаңыртууну жана оңдоону суроого;', 'арыз менен Коомдун сайтындагы электрондук капчыкка жана жеке кабинетке кирүүнү бөгөттөөгө;', 'жеке маалыматтарды иштетүү боюнча Коомго кайрылууга;', 'укуктарын Кыргыз Республикасынын мыйзамдарында белгиленген тартипте коргоого.'] },
        ],
      },
      {
        title: '8. Сактоо мөөнөтү',
        blocks: [{ p: 'Жеке маалыматтарды сактоо мөөнөтү Кыргыз Республикасынын мыйзамдары, Улуттук банктын ченемдик актылары жана Коомдун ички документтери менен аныкталат.' }],
      },
      {
        title: '9. Cookies жана окшош технологиялар',
        blocks: [
          { p: 'Системанын ишин жакшыртуу жана коопсуздукту камсыз кылуу үчүн cookies жана окшош технологияларды колдонобуз:' },
          { pairs: [
            { title: 'Зарыл cookies', text: 'Системанын иши жана коопсуздугу үчүн' },
            { title: 'Аналитикалык cookies', text: 'Системанын колдонулушун талдоо үчүн' },
            { title: 'Функционалдык cookies', text: 'Жөндөөлөрүңүздү эстеп калуу үчүн' },
          ] },
        ],
      },
      {
        title: '10. Саясаттагы өзгөрүүлөр',
        blocks: [
          { p: 'Бул Саясатты өзгөртө алабыз. Өзгөрүүлөр жөнүндө жеке кабинет же электрондук почта аркылуу кабарланат.' },
          { p: 'Саясат өзгөргөндөн кийин кызматты колдонууну улантуу жаңы шарттарга макулдук дегенди билдирет.' },
        ],
      },
      {
        title: '11. Байланыш',
        blocks: [{ p: 'Жеке маалыматтарды иштетүү боюнча суроолор үчүн укуктук маалымат барагынын астындагы байланыштарды колдонуңуз.' }],
      },
    ],
  },
}

export const termsOfService: LegalPack = {
  ru: {
    title: 'Условия использования',
    meta: ['Версия: 1.0', 'Дата: 25.06.2025', 'Статус: Действует'],
    effective: '25.06.2025',
    version: '1.0',
    sections: [
      { title: '1. Общие положения', blocks: [{ p: 'Настоящие Условия использования (далее — «Условия») регулируют порядок предоставления услуг платежной системы AlfaBitPay и определяют права и обязанности сторон.' }] },
      { title: '2. Услуги системы', blocks: [{ p: 'Платежная система AlfaBitPay предоставляет следующие услуги:' }, { ul: ['Создание и управление Вашими счетами в личном Кабинете', 'Перевод денежных средств между пользователями', 'Платежи за товары и услуги', 'Пополнение и вывод средств', 'Обмен валют', 'Предоставление отчетности'] }] },
      { title: '3. Порядок предоставления услуг', blocks: [{ p: 'Услуги предоставляются в соответствии с действующим законодательством Кыргызской Республики и внутренними регламентами системы.' }] },
      { title: '4. Ограничения и ответственность', blocks: [{ p: 'Система не несет ответственности за убытки, возникшие в результате действий пользователей или третьих лиц.' }] },
      { title: '5. Контактная информация', blocks: [{ p: 'По вопросам использования услуг обращайтесь через контакты, указанные внизу страницы правовой информации.' }] },
    ],
  },
  en: {
    title: 'Terms of Service',
    meta: ['Version: 1.0', 'Date: 25.06.2025', 'Status: Active'],
    effective: '25.06.2025',
    version: '1.0',
    sections: [
      { title: '1. General provisions', blocks: [{ p: 'These Terms of Service (the Terms) govern how AlfaBitPay payment system services are provided and set out the rights and obligations of the parties.' }] },
      { title: '2. System services', blocks: [{ p: 'The AlfaBitPay payment system provides the following services:' }, { ul: ['Creating and managing your accounts in the personal account', 'Transfers between users', 'Payments for goods and services', 'Top-ups and withdrawals', 'Currency exchange', 'Reporting'] }] },
      { title: '3. How services are provided', blocks: [{ p: 'Services are provided in accordance with the laws of the Kyrgyz Republic and the system’s internal rules.' }] },
      { title: '4. Limits and liability', blocks: [{ p: 'The system is not liable for losses caused by the actions of users or third parties.' }] },
      { title: '5. Contact information', blocks: [{ p: 'For questions about the services, use the contacts listed at the bottom of the legal information page.' }] },
    ],
  },
  ky: {
    title: 'Колдонуу шарттары',
    meta: ['Версия: 1.0', 'Күнү: 25.06.2025', 'Статус: Күчүндө'],
    effective: '25.06.2025',
    version: '1.0',
    sections: [
      { title: '1. Жалпы жоболор', blocks: [{ p: 'Бул Колдонуу шарттары (мындан ары — Шарттар) AlfaBitPay төлөм системасынын кызматтарын көрсөтүү тартибин жөнгө салат жана тараптардын укуктары менен милдеттерин аныктайт.' }] },
      { title: '2. Системанын кызматтары', blocks: [{ p: 'AlfaBitPay төлөм системасы төмөнкү кызматтарды көрсөтөт:' }, { ul: ['Жеке кабинетте эсептерди түзүү жана башкаруу', 'Колдонуучулардын ортосунда акча которуу', 'Товар жана кызмат үчүн төлөмдөр', 'Толуктоо жана каражат чыгаруу', 'Валюта алмашуу', 'Отчет берүү'] }] },
      { title: '3. Кызмат көрсөтүү тартиби', blocks: [{ p: 'Кызматтар Кыргыз Республикасынын колдонуудагы мыйзамдарына жана системанын ички регламенттерине ылайык көрсөтүлөт.' }] },
      { title: '4. Чектөөлөр жана жоопкерчилик', blocks: [{ p: 'Система колдонуучулардын же үчүнчү жактардын аракеттеринен келип чыккан чыгымдар үчүн жооп бербейт.' }] },
      { title: '5. Байланыш', blocks: [{ p: 'Кызматтарды колдонуу боюнча суроолор үчүн укуктук маалымат барагынын астындагы байланыштарды колдонуңуз.' }] },
    ],
  },
}

export const personalDataConsent: LegalPack = {
  ru: {
    title: 'Согласие на сбор и обработку персональных данных',
    meta: ['Версия: 1.0', 'Дата: 13.08.2026', 'Статус: Действует'],
    effective: '13.08.2026',
    version: '1.0',
    sections: [
      { title: '1. Общие положения', blocks: [
        { p: 'Настоящее Согласие определяет условия сбора и обработки персональных данных пользователей платежной системы AlfaBitPay ОсОО «АльфаБит Пэймэнтс» (далее – Общество).' },
        { p: 'Давая согласие, Пользователь подтверждает достоверность представленной информации и соглашается на сбор и обработку персональных данных, передачу третьим лицам в соответствии с Законом Кыргызской Республики «Об информации персонального характера» и международными договорами, а также на трансграничную передачу персональных данных при необходимости оказания платежных услуг.' },
      ] },
      { title: '2. Цели обработки', blocks: [
        { p: 'Персональные данные обрабатываются Обществом в целях:' },
        { ul: ['идентификации и обслуживания Пользователя в платежной системе AlfaBitPay;', 'исполнения договоров и оказания платежных услуг;', 'соблюдения требований законодательства Кыргызской Республики и актов НБКР;', 'обеспечения безопасности операций и предотвращения мошенничества.'] },
      ] },
      { title: '3. Права Пользователя', blocks: [
        { p: 'Пользователь вправе:' },
        { ul: ['получать информацию об обработке своих персональных данных;', 'запрашивать уточнения, обновления и исправления персональных данных;', 'по заявлению блокировать доступ к электронному кошельку и личному кабинету на сайте Общества;', 'обращаться в Общество по вопросам обработки персональных данных;', 'защищать свои права в порядке, установленном законодательством Кыргызской Республики.'] },
      ] },
      { title: '4. Срок хранения', blocks: [{ p: 'Срок хранения персональных данных определяется законодательством Кыргызской Республики, нормативными актами Национального банка Кыргызской Республики и внутренними документами Общества.' }] },
      { title: '5. Контактная информация', blocks: [{ p: 'По вопросам обработки персональных данных обращайтесь через контакты, указанные внизу страницы правовой информации.' }] },
    ],
  },
  en: {
    title: 'Consent to the collection and processing of personal data',
    meta: ['Version: 1.0', 'Date: 13.08.2026', 'Status: Active'],
    effective: '13.08.2026',
    version: '1.0',
    sections: [
      { title: '1. General provisions', blocks: [
        { p: 'This Consent sets the terms for collecting and processing personal data of users of the AlfaBitPay payment system operated by AlfaBit Payments LLC (the Company).' },
        { p: 'By giving consent, the User confirms that the information provided is accurate and agrees to the collection and processing of personal data, its transfer to third parties under the Law of the Kyrgyz Republic “On Personal Information” and international treaties, and to cross-border transfer where that is needed to provide payment services.' },
      ] },
      { title: '2. Purposes of processing', blocks: [
        { p: 'The Company processes personal data in order to:' },
        { ul: ['identify and serve the User in the AlfaBitPay payment system;', 'perform contracts and provide payment services;', 'comply with the laws of the Kyrgyz Republic and NBKR acts;', 'keep operations secure and prevent fraud.'] },
      ] },
      { title: '3. User rights', blocks: [
        { p: 'The User has the right to:' },
        { ul: ['receive information about how their personal data is processed;', 'ask for personal data to be clarified, updated or corrected;', 'request that access to the e-wallet and personal account on the Company’s website be blocked;', 'contact the Company about personal data processing;', 'protect their rights as provided by the laws of the Kyrgyz Republic.'] },
      ] },
      { title: '4. Retention', blocks: [{ p: 'Personal data is kept for the period set by the laws of the Kyrgyz Republic, the regulations of the National Bank of the Kyrgyz Republic and the Company’s internal documents.' }] },
      { title: '5. Contact information', blocks: [{ p: 'For questions about personal data processing, use the contacts listed at the bottom of the legal information page.' }] },
    ],
  },
  ky: {
    title: 'Жеке маалыматтарды чогултууга жана иштетүүгө макулдук',
    meta: ['Версия: 1.0', 'Күнү: 13.08.2026', 'Статус: Күчүндө'],
    effective: '13.08.2026',
    version: '1.0',
    sections: [
      { title: '1. Жалпы жоболор', blocks: [
        { p: 'Бул Макулдук AlfaBitPay төлөм системасынын колдонуучуларынын жеке маалыматтарын «АльфаБит Пэймэнтс» ЖЧКсы (мындан ары — Коом) чогултуу жана иштетүү шарттарын аныктайт.' },
        { p: 'Макулдук берүү менен Колдонуучу берилген маалыматтын тууралыгын ырастайт жана жеке маалыматтарды чогултууга жана иштетүүгө, Кыргыз Республикасынын «Жеке мүнөздөгү маалымат жөнүндө» Мыйзамына жана эл аралык келишимдерге ылайык үчүнчү жактарга берүүгө, ошондой эле төлөм кызматтарын көрсөтүү үчүн зарыл болсо чек ара аркылуу берүүгө макул болот.' },
      ] },
      { title: '2. Иштетүүнүн максаттары', blocks: [
        { p: 'Жеке маалыматтар Коом тарабынан төмөнкү максаттарда иштетилет:' },
        { ul: ['Колдонуучуну AlfaBitPay төлөм системасында идентификациялоо жана тейлөө;', 'келишимдерди аткаруу жана төлөм кызматтарын көрсөтүү;', 'Кыргыз Республикасынын мыйзамдарынын жана УБКР актыларынын талаптарын сактоо;', 'операциялардын коопсуздугун камсыз кылуу жана алдамчылыктын алдын алуу.'] },
      ] },
      { title: '3. Колдонуучунун укуктары', blocks: [
        { p: 'Колдонуучу төмөнкүлөргө укуктуу:' },
        { ul: ['жеке маалыматтарын иштетүү жөнүндө маалымат алууга;', 'жеке маалыматтарын тактоону, жаңыртууну жана оңдоону суроого;', 'арыз менен Коомдун сайтындагы электрондук капчыкка жана жеке кабинетке кирүүнү бөгөттөөгө;', 'жеке маалыматтарды иштетүү боюнча Коомго кайрылууга;', 'укуктарын Кыргыз Республикасынын мыйзамдарында белгиленген тартипте коргоого.'] },
      ] },
      { title: '4. Сактоо мөөнөтү', blocks: [{ p: 'Жеке маалыматтарды сактоо мөөнөтү Кыргыз Республикасынын мыйзамдары, Улуттук банктын ченемдик актылары жана Коомдун ички документтери менен аныкталат.' }] },
      { title: '5. Байланыш', blocks: [{ p: 'Жеке маалыматтарды иштетүү боюнча суроолор үчүн укуктук маалымат барагынын астындагы байланыштарды колдонуңуз.' }] },
    ],
  },
}
